import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DeepLinkProfile from './pages/DeepLinkProfile';
import DeepLinkInvite from './pages/DeepLinkInvite';
import NotFound from './pages/NotFound';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import DeleteAccount from './pages/DeleteAccount';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage/>} />
      <Route path="/delete-account" element={<DeleteAccount/>} />
      <Route path="/profile/:id" element={<DeepLinkProfile />} />
      <Route path="/invite/:code" element={<DeepLinkInvite />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
